import { GenerateTokenMutation, UserFragment } from "@saleor/graphql";
import {
  GetExternalAccessTokenData,
  GetExternalAuthUrlData,
  LoginData
} from "@saleor/sdk";

export interface RequestExternalLoginInput {
  redirectUri: string;
}

export interface ExternalLoginInput {
  code: string;
  state: string;
}

export interface RequestExternalLogoutInput {
  returnTo: string;
}

export type UserContextError =
  | "loginError"
  | "externalLoginError"
  | "serverError";

export enum Zone {
  Domestic = "Domestic",
  Export = "Export"
}

export interface Company {
  soldToCode: string;
  soldToName: string;
  id: string;
  showPoUpload: boolean;
}

export interface UserContext {
  loginByToken: (
    accessToken: string
  ) => Promise<GenerateTokenMutation["generateToken"]>;
  login: (username: string, password: string) => Promise<LoginData>;
  loginByExternalPlugin: (
    pluginId: string,
    input: ExternalLoginInput
  ) => Promise<GetExternalAccessTokenData>;
  logout: () => Promise<void>;
  requestLoginByExternalPlugin: (
    pluginId: string,
    input: RequestExternalLoginInput
  ) => Promise<GetExternalAuthUrlData>;
  user?: UserFragment;
  authenticating: boolean;
  authenticated: boolean;
  error?: UserContextError;
  zone?: Zone;
  setZone?: (Zone) => void;
  company?: string;
  setCompany?: (string) => void;
  listCompany: Company[];
  soldToId: string;
  setSoldToId?: (string) => void;
  tokenRefresh: () => Promise<boolean>;
  tokenRefreshApp?: () => Promise<void>;
}
